import * as React from 'react';
import OverviewComponent from "../components/OverviewComponent/OverviewComponent";

import {connect} from "react-redux";
import {deleteSelectedSources, deselectAll, selectAll, toggleSelect} from "../actions/literatureWizardActions";
import ISource from "../interfaces/ISource";

export interface IOverviewProps {
    dispatchDeleteSelectedSources: () => any,
    dispatchDeselectAll: (ids: string[]) => any,
    dispatchSelectAll: (ids: string[]) => any,
    dispatchToggleSelect: (id: string) => any,
    selected: string[],
    sources: ISource[],
    history: any
}

class OverviewContainer extends React.PureComponent<IOverviewProps> {
    public render() {
        return (
            <OverviewComponent {...this.props}/>
        );
    }
}

const mapStateToProps = (store: any) => ({
    selected: store.literature.selected,
    sources: store.literature.sources,
});

const mapDispatchToProps = {
    dispatchDeleteSelectedSources: deleteSelectedSources,
    dispatchDeselectAll: deselectAll,
    dispatchSelectAll: selectAll,
    dispatchToggleSelect: toggleSelect,
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewContainer);



// WEBPACK FOOTER //
// ./src/containers/OverviewContainer.tsx